import { useEffect, useState } from 'react';
import { useCalibration } from '../../../context/calibrationContext';
import { useReceiveMessage } from '../../../context/messageContext';
import { DeviceWaitView } from '../../session/calibration/ClinicianCalibrationViews';
import { useCalibrationSync } from '../../session/calibration/sync';
import { useSessionPeople } from '../../session/hooks';

// C3.1 "Please wait for the patient to select their device" -> C3.2 "<patient> has selected the
// iPhone 7". The patient's selection arrives as the usual `rulerDimensions` message (now carrying
// content.device {make, model}); optician-view runs the ruler maths on it. The device name is also
// in the shared session state (calibration.device), which covers a re-joining clinician.
const DeviceCalibration = ({ setStep, postMessage, response }) => {
  const received = useReceiveMessage();
  const people = useSessionPeople();
  const { updateCalibrationData, calibrationData } = useCalibration();
  const { state, patchCalibration } = useCalibrationSync();
  const [device, setDevice] = useState(null);

  useEffect(() => {
    if (received?.type === 'rulerDimensions' && received?.content?.device?.model) setDevice(received.content.device);
  }, [received]);

  const stateDevice = state?.calibration?.method === 'device' ? state?.calibration?.device : null;
  const selected = device || stateDevice;
  const hasValues = Boolean(selected && (response || stateDevice));
  // Values from this call's rulerDimensions message, or (re-join) from the stored device.
  const { widthMm, heightMm } = response ? calibrationData?.rulerDimensions || {} : { widthMm: stateDevice?.screen_mm?.[0], heightMm: stateDevice?.screen_mm?.[1] };

  const switchMethod = (method) => {
    postMessage({ type: method === 'card' ? 'stepCardCalibration' : 'stepRulerCalibration' });
    patchCalibration({ method });
    setStep(method);
  };

  const confirmDevice = () => {
    updateCalibrationData({ screenCalibrated: true });
    postMessage({ type: 'calibration-selection' });
    patchCalibration({
      method: 'device',
      screen_calibrated: true,
      device: selected?.make && selected?.model && widthMm && heightMm ? { make: selected.make, model: selected.model, screen_mm: [widthMm, heightMm] } : stateDevice,
      card_ratio: calibrationData?.pixelDensity || null,
    });
    setStep('calibration-selection');
  };

  return (
    <DeviceWaitView
      patientName={people.patientName}
      device={hasValues ? selected?.model : null}
      widthMm={hasValues ? widthMm : null}
      heightMm={hasValues ? heightMm : null}
      onUseCard={() => switchMethod('card')}
      onUseRuler={() => switchMethod('ruler')}
      onBack={() => {
        postMessage({ type: 'screen-calibration' });
        setStep('screen-calibration');
      }}
      onNext={confirmDevice}
    />
  );
};

export default DeviceCalibration;
